<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="modal-title d-flex gap-2 align-items-center">
          <ng-container i18n>LOS Discounts</ng-container>
        </div>
        <div class="flex-fill"></div>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body p-3">
      <div class="container-box p-3">
        <app-los-discount-table [channelId]="data.channelId" [rentalId]="data.rentalId"></app-los-discount-table>
      </div>
    </div>
  </div>
</div>
